import request from '@/utils/request'

const commonURL = {
  UploadQiniu: '/public/upload-file-qi-niu',
  UploadFile: '/public/upload-file',
  GetOssKey: '/public/get-oss-sign',
  Label: '/public/labels',
  LineList: '/public/line-list',
  LineTree: '/public/line-tree',
  LineNewList: '/public/line-list-new',
  QueryUser: '/public/query-user',
  CheckOrder: '/public/check-order'
}

export function QiniuFile (data) {
  return request({
    url: commonURL.UploadQiniu,
    method: 'post',
    data
  })
}

export function UploadFile (data) {
  return request({
    url: commonURL.UploadFile,
    method: 'post',
    data
  })
}

export function Label (data) {
  return request({
    url: commonURL.Label,
    method: 'post',
    data
  })
}

export function LineList (data) {
  return request({
    url: commonURL.LineList,
    method: 'post',
    data
  })
}

export function LineListTree (data) {
  return request({
    url: commonURL.LineTree,
    method: 'post',
    data
  })
}

export function LineListNew (data) {
  return request({
    url: commonURL.LineNewList,
    method: 'post',
    data
  })
}
export function GetOssKey (data) {
  return request({
    url: commonURL.GetOssKey,
    method: 'get',
    data
  })
}
/**
 * 查询用户
 * @param {*} data
 * @returns
 */
export function QueryUser (data) {
  return request({
    url: commonURL.QueryUser,
    method: 'post',
    data
  })
}
/**
 * 检查订单号存不存在
 * @param {*} data
 * @returns
 */
export function CheckOrder (data) {
  return request({
    url: commonURL.CheckOrder,
    method: 'post',
    data
  })
}

export default {
  QiniuFile,
  UploadFile,
  GetOssKey,
  Label,
  LineList,
  LineListTree,
  LineListNew,
  QueryUser,
  CheckOrder
}
